export default {
    data: () => ({
        lendingKitColumns: [
            {
                label: "id",
                field: "id",
                sortable: true,
                required: true
            }, {
                label: "stock status",
                field: "stock_status.description",
                required: true,
                sortable: true
            }, {
                label: "lending point",
                field: "lending_point.description",
                required: true
            }, {
                label: "identifier",
                field: "identifier",
                sortable: true,
                required: true
            }, {
                label: "codentify",
                field: "codentify",
                sortable: true
            }, {
                label: "model",
                field: "lending_kit_color.lending_kit_model.description",
                required: true
            }, {
                label: "sku code",
                field: "lending_kit_color.sku",
                required: true
            }, {
                label: "sku description",
                field: "lending_kit_color.description",
                required: true
            }, {
                label: "image sku",
                field: "lending_kit_color.image",
                required: true
            }, {
                label: "child codentify 1",
                field: "child_codentify_1",
                sortable: true
            }, {
                label: "child codentify 2",
                field: "child_codentify_2",
                sortable: true
            }, {
                label: "status",
                field: "lending_kit_status.description",
                sortable: true
            }, {
                label: "first lending",
                field: "first_lending_id",
                sortable: true
            }, {
                label: "circular lending eligible",
                field: "is_circular_lending",
                sortable: true
            }, {
                label: "lending count",
                field: "lending_count",
                sortable: true
            }
        ]
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/lendingKitColumns.js